import PG from "./ta_pg";
import i18n from "./i18n";
import ta_launcher from "./http_launcher_producer";

export default class TAUtils {
  static state = {
    detectRequests: 0,
    confirmAttempts: 0,
    validCreds: null,
    launchAttempted: false,
    refreshWarning: false,
    busyHeartBeat: false,
    tryProxy: false,
    proxyResult: "",
  };

  static detectOS = () => {
    let os = "linux";
    let agent = navigator.userAgent || ""; // if undefined, make an empty string which will result in Linux/Other
    agent = agent.toLowerCase();

    if (agent.indexOf("mac") > -1) {
      os = "mac";
    } else if (agent.indexOf("windows") > -1) {
      os = "windows";
    }

    return os;
  };

  static launcherInitialized = () => {
    if (typeof ta_launcher == "undefined") {
      return false;
    }
    return true;
  };

  static localStorageConfiguration = {
    saveItem: function (itemName, itemValue) {
      tempObj = {};
      //hardcode up to we have a definition about how cookies should work for filecalyst clients.
      tempObj.expires = 365;
      itemValue.objectStamp = true;
      if (typeof itemValue === "string") {
        $.cookie(itemName, itemValue, tempObj);
      } else {
        $.cookie(itemName, JSON.stringify(itemValue), tempObj);
      }
    },
    getItem: function (itemName) {
      try {
        return JSON.parse($.cookie(itemName));
      } catch (e) {
        console.warn(
          "itemName: " + itemName,
          "cookie: " + $.cookie(itemName),
          e
        );
        return null;
      }
    },
    insertProperty: function (itemName, propertyName, propertyValue) {
      let verifyItem = TAUtils.localStorageConfiguration.getItem(itemName);
      if (verifyItem !== null) {
        let tempObject = {};
        if (typeof verifyItem === "string") {
          tempObject = JSON.parse(verifyItem);
        } else {
          tempObject = verifyItem;
        }
        if (
          tempObject !== undefined &&
          typeof tempObject === "object" &&
          tempObject !== null
        ) {
          tempObject[propertyName] = propertyValue;
          TAUtils.localStorageConfiguration.saveItem(itemName, tempObject);
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    resetLocalStorage: function (itemName) {
      $.cookie(itemName, null);
    },
  };

  static getPortToListen = () => {
    let savedConfig = TAUtils.localStorageConfiguration.getItem(
      "filecatalystTAPortValue"
    );
    if (savedConfig !== null && !$.isEmptyObject(savedConfig)) {
      return TAUtils.localStorageConfiguration.getItem(
        "filecatalystTAPortValue"
      );
    } else {
      return localAgent.portDefault;
    }
  };

  static setPortToListen = (port) => {
    if (TAUtils.launcherInitialized() == false) {
      throw new Error(
        "Cannot update the listener port without HTTP Launcher initialized."
      );
    }

    port = parseInt(port);

    ta_launcher.setLocal("port", port);
  };

  static getLinkForOS = (kindOfLink, os) => {
    let parentDir = "";
    let linkMap = {
      installDoc: {
        windows: i18n.t("webDeployment.docWindowsLocation"),
        mac: i18n.t("webDeployment.docMacLocation"),
        linux: i18n.t("webDeployment.docLinuxLocation"),
      },
      download: {
        windows: pg.config.links.installWindowsLocation,
        mac: pg.config.links.installMacLocation,
        linux: pg.config.links.installLinuxLocation,
      },
    };

    // although this function should usually be called without passing in an os,
    // you are able to explicitly pass "Windows", "Mac", or "Linux" to bypass detection.
    // let's normalize the case:
    if (typeof os === "string") {
      os = os.toLowerCase();
    }

    // if the kindOfLink ("download" or "installDoc") is not provided, assume we are
    // after the installDoc
    kindOfLink = kindOfLink ? kindOfLink : "installDoc";

    // TODO: Make a unified path structure that we won't have to worry about.
    // Hacky fix when using weblink. No other folder will trigger this (unless they also have a weblinkDataDiv ID.)
    if ($("#webLinkInfo").length > 0 && kindOfLink === "installDoc") {
      parentDir = "../";
    }

    // TODO: Make a unified path structure that we won't have to worry about.
    // Hacky fix when using Express from Deployment. No other folder will trigger this
    // (unless they also have a .deployment-version.ta-express-deployed-app CSS selection)
    if (
      (isDeployedExpressApp() || isFCLoginPage()) &&
      kindOfLink === "installDoc"
    ) {
      parentDir = "../../";
    }

    // only detect if os is not explicitly passed in with the params
    if (
      typeof os === "undefined" ||
      (os !== "mac" && os !== "windows" && os !== "linux")
    ) {
      os = TAUtils.detectOS();
    }

    // set the link with best-known results
    return parentDir + linkMap[kindOfLink][os];
  };

  /**
   * Checks to see if the application needs to be updated.
   *
   * @param  {Object}     transferAgentVersion
   *                                         The object containing the version data we're checking as retrieved from
   *                                         the TA.
   * @param  {string}     webApplicationVersion
   *                                         The version string reported by the web application as a basis of
   *                                         comparison to the TransferAgent itself.
   * @return {number|NaN}                    The result of the version check. Is -1 when the version given is older
   *                                         than the current version. Is 1 when the version given is newer than the
   *                                         current version. Is 0 when the version given is the same as the current
   *                                         version. It is NaN if the version given is invalid.
   */
  static compareVersion = (transferAgentVersion, webApplicationVersion) => {
    //check if the user declined the upgrade for this version.
    if (
      localStorage.getItem("webLink.VersionFoundWhenUserDeclinedUpdate") ===
      webApplicationVersion
    )
      return;

    let intCurrentFile = 0;
    let fileVersionArray = [];
    let dataVersionArray = [];
    let versionDepth = 0;
    let result = NaN;

    //current version in this file
    let splitFileVersion = webApplicationVersion.split(" ");

    if (splitFileVersion[0] === "Enterprise") {
      let tempStatus = splitFileVersion[2];
      splitFileVersion = splitFileVersion[1].replace("v", "").split(".");
      splitFileVersion = [
        splitFileVersion[0] + "." + splitFileVersion[1],
        tempStatus,
        splitFileVersion[2],
      ];
    }

    // Make arrays out of version strings:
    fileVersionArray = splitFileVersion[0].split(".");
    dataVersionArray = transferAgentVersion.version.split(".");

    // Make sure the arrays are the same length
    versionDepth = fileVersionArray.length;
    if (dataVersionArray.length > versionDepth) {
      versionDepth = dataVersionArray.length;
    }

    // Converting legacy status version name to status version number
    try {
      intCurrentFile = parseInt(splitFileVersion[1]);

      if (isNaN(intCurrentFile)) {
        switch (splitFileVersion[1].toUpperCase()) {
          case "ALPHA":
            intCurrentFile = 1;
            break;

          case "BETA":
            intCurrentFile = 2;
            break;

          case "PRODUCTION":
          case "ENTERPRISE":
            intCurrentFile = 3;
            break;

          default:
            intCurrentFile = 0;
        }
      }
    } catch (e) {
      intCurrentFile = 0;
    }

    // Add the status version number to the arrays.
    fileVersionArray[versionDepth] = intCurrentFile;
    dataVersionArray[versionDepth] = transferAgentVersion.statusInt;

    // Add the build version number to the arrays.
    fileVersionArray.push(parseInt(splitFileVersion[2]));
    dataVersionArray.push(transferAgentVersion.build);

    // Go through each version number and see how they compare
    $.each(fileVersionArray, function (index, currentValue) {
      // We sanitize each value into a good integer
      let fileVersionNumber = parseInt(currentValue) || 0;
      let dataVersionNumber = parseInt(dataVersionArray[index]) || 0;

      // If the file version is larger than the version we passed to this function
      if (fileVersionNumber > dataVersionNumber) {
        result = -1;
        return false;

        // If the file version is smaller than the version we passed to this function
      } else if (fileVersionNumber < dataVersionNumber) {
        result = 1;
        return false;

        // If the file version is the same as the version we passed to this function
      } else {
        result = 0;
      }
    });

    // Return the results of our comparison.
    return result;
  };

  /**
   * Stores the introduction of new or changed API methods
   *
   * @param {string} taVersion
   */
  static apiChecks = (taVersion) => {
    PG.available.statusViaGet =
      TAUtils.compareVersion(taVersion, "3.6 Beta 5") >= 0 ? true : false;
    PG.available.serviceStatus =
      TAUtils.compareVersion(taVersion, "3.7 Beta 1") >= 0 ? true : false;
  };

  static checkRunningAsService = (successCallback, errorCallback) => {
    let url = PG.baseUrl("serviceStatus");

    $.ajax({
      url: url,
      type: "GET",
      dataType: "json",
      success: function (data) {
        if (successCallback) {
          successCallback(data);
        }
      },
      error: function (xhr) {
        if (errorCallback) {
          errorCallback(xhr);
        }
      },
    });
  };

  static runningAsServiceStatusGetSet = (data) => {
    if (data) {
      PG.state.isRunningAsService =
        typeof data.isServiceRunning !== "undefined"
          ? data.isServiceRunning
          : data.serviceRunning;
    } else {
      return PG.state.isRunningAsService;
    }
  };
}

function isDeployedExpressApp() {
  return $(".deployment-version.ta-express-deployed-app").length > 0;
}

function isFCLoginPage() {
  return $(".fcloginpage").length > 0;
}
